module.exports = __webpack_public_path__ + "src/assets/img/nordic.b85b23a8.png";